export enum CodeMirrorLanguageType {
  JavaScriptAndNodeFields = 'JavaScriptAndNodeFields',
  DoubleBraceNodeFields = 'DoubleBraceNodeFields',
  NodeFields = 'NodeFields',
}

/**
 * For blocks with additional root level fields,
 * we can provide a list of autocomplete labels.
 */
export type AutocompleteLabels = readonly string[];
